<script>
import { loadSystemInfo } from '@/api/system'
import nodeID from '@/mixins/nodeID'
import TempalteSelector from './TempalteSelector.vue'

export default {
  name: 'FormatsSelector',

  extends: TempalteSelector,

  mixins: [nodeID],

  props: {
    formats: { type: Array, default: () => null },
  },

  created() {
    this.init()
  },

  methods: {
    getList() {
      return new Promise((resolve) => {
        let res = ['json', 'binary', 'protobuf', 'delimited', 'custom']
        loadSystemInfo(this.nodeID).then((resp) => {
          if (resp.data.version.toLowerCase().indexOf('can') !== -1) {
            res.push('canjson')
          }
        })
        if (this.formats) {
          res = this.formats
        }
        resolve(res)
      })
    },
  },
}
</script>
